import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity, updateEntity, createEntity, reset } from './comex-settings.reducer';

import { IComexSettings } from 'app/shared/model/comex-settings.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const ComexSettingsUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const comexSettingsEntity = useAppSelector(state => state.comexSettings.entity);
  const loading = useAppSelector(state => state.comexSettings.loading);
  const updating = useAppSelector(state => state.comexSettings.updating);
  const updateSuccess = useAppSelector(state => state.comexSettings.updateSuccess);
  const handleClose = () => {
    props.history.push('/comex-settings' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    values.operationStartTime = convertDateTimeToServer(values.operationStartTime);
    values.operationEndTime = convertDateTimeToServer(values.operationEndTime);
    values.currencyRateRefresh = convertDateTimeToServer(values.currencyRateRefresh);

    const entity = {
      ...comexSettingsEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          operationStartTime: displayDefaultDateTime(),
          operationEndTime: displayDefaultDateTime(),
          currencyRateRefresh: displayDefaultDateTime(),
        }
      : {
          ...comexSettingsEntity,
          operationStartTime: convertDateTimeFromServer(comexSettingsEntity.operationStartTime),
          operationEndTime: convertDateTimeFromServer(comexSettingsEntity.operationEndTime),
          currencyRateRefresh: convertDateTimeFromServer(comexSettingsEntity.currencyRateRefresh),
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="comexApp.comexSettings.home.createOrEditLabel" data-cy="ComexSettingsCreateUpdateHeading">
            <Translate contentKey="comexApp.comexSettings.home.createOrEditLabel">Create or edit a ComexSettings</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="comex-settings-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('comexApp.comexSettings.operationStartTime')}
                id="comex-settings-operationStartTime"
                name="operationStartTime"
                data-cy="operationStartTime"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('comexApp.comexSettings.operationEndTime')}
                id="comex-settings-operationEndTime"
                name="operationEndTime"
                data-cy="operationEndTime"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('comexApp.comexSettings.currencyRateRefresh')}
                id="comex-settings-currencyRateRefresh"
                name="currencyRateRefresh"
                data-cy="currencyRateRefresh"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('comexApp.comexSettings.serverStatus')}
                id="comex-settings-serverStatus"
                name="serverStatus"
                data-cy="serverStatus"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('comexApp.comexSettings.alshmokhAPIServerStatus')}
                id="comex-settings-apiServerStatus"
                name="apiServerStatus"
                data-cy="apiServerStatus"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('comexApp.comexSettings.feeNormalValue')}
                id="comex-settings-feeNormalValue"
                name="feeNormalValue"
                data-cy="feeNormalValue"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('comexApp.comexSettings.feeMediumValue')}
                id="comex-settings-feeMediumValue"
                name="feeMediumValue"
                data-cy="feeMediumValue"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('comexApp.comexSettings.notifyCancelUserID')}
                id="comex-settings-notifyCancelUserID"
                name="notifyCancelUserID"
                data-cy="notifyCancelUserID"
                type="text"
              />
              <ValidatedField
                label={translate('comexApp.comexSettings.alshmokhAccountNumber')}
                id="comex-settings-alshmokhAccountNumber"
                name="alshmokhAccountNumber"
                data-cy="alshmokhAccountNumber"
                type="text"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/comex-settings" replace>
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ComexSettingsUpdate;
